module.exports = "/_next/static/images/5ae6ac1a99775149bdf973af53d6e1d6-hero-xs.jpg.webp";